import cn from "classnames";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "shared/components/Text";
import reviewBorder from "assets/images/review-border.png";
import reviewUpperQuotationMark from "assets/images/review-upper-quotation-mark.png";
import reviewLowerQuotationMark from "assets/images/review-lower-quotation-mark.png";

import css from "./styles.module.scss";

export const ReviewSection = ({ passedRef }) => {
  const { t, i18n } = useTranslation();

  const content = useMemo(() => {
    return t("reviewSection.reviews", {
      returnObjects: true,
    });
  }, [i18n.language]);

  return (
    <div ref={passedRef} className={css.ReviewSection}>
      <div className={css.contentBox}>
        <Text type="white" className={css.title} bold secondaryFamily>
          {t("reviewSection.title")}
        </Text>
        <div className={css.contentContainer}>
          {content.map((el, i) => {
            return (
              <div key={i} className={css.contentItemContainer}>
                <img
                  src={reviewBorder}
                  alt="review border"
                  title="Review border"
                  className={css.border}
                />
                <Text type="white" className={css.reviewText}>
                  {el.content}
                </Text>
                <Text type="white" className={css.reviewAuthor} bold>
                  {el.author}
                </Text>
                <img
                  src={reviewUpperQuotationMark}
                  alt="review upper quotation mark"
                  title="Review quotation mark"
                  className={css.upperQuotationMark}
                />
                <img
                  src={reviewLowerQuotationMark}
                  alt="review lower quotation mark"
                  title="Review quotation mark"
                  className={css.lowerQuotationMark}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
